export default {
	"id": 111,
	"label": "dsaid_sexual_assaults",
	"rootId": 114,
	"tracked": "sexual assaults",
	"dataSourceMetadata": {
		"source": "upload",
		"fileIds": [
			55010,
			32001
		],
		"uploadFile": {
			"name": "dsaid_sexual_assaults (1).csv",
			"lastModified": "2021-01-25T14:08:21Z"
		},
		"fetched": false,
		"skipNotModified": false,
		"id": 701,
		"columns": [
			"Case ID",
			"DSAID Control Number",
			"Date of Report to DoD",
			"Victim Gender",
			"Victim Age at the Time of Incident",
			"Victim Pay Grade",
			"DSAID Case Status",
			"Date of Incident",
			"Was Alcohol Involved? (Subject/Victim)",
			"Victim UIC",
			"Victim Relationship to Subject",
			"Subject1 UIC",
			"Subject1 Gender",
			"Subject1 Pay Grade"
		],
		"primaryKey": "Case ID",
		"status": "ready",
		"numRowsProcessed": 3131,
		"automaticFieldsByIntermediateColumn": {
			"fields": [
				{
					"label": "Case ID",
					"dataType": "number",
					"example": "33449365"
				},
				{
					"label": "DSAID Control Number",
					"dataType": "text",
					"example": "UUAR-00007936-2017-00207"
				},
				{
					"label": "Date of Report to DoD",
					"dataType": "date",
					"example": "1/11/17"
				},
				{
					"label": "Victim Gender",
					"dataType": "text",
					"example": "Female"
				},
				{
					"label": "Victim Age at the Time of Incident",
					"dataType": "number",
					"example": "25"
				},
				{
					"label": "Victim Pay Grade",
					"dataType": "text",
					"example": "E-4"
				},
				{
					"label": "DSAID Case Status",
					"dataType": "text",
					"example": "Closed"
				},
				{
					"label": "Date of Incident",
					"dataType": "date",
					"example": "11/15/16"
				},
				{
					"label": "Was Alcohol Involved? (Subject/Victim)",
					"dataType": "text",
					"example": "Unknown"
				},
				{
					"label": "Victim UIC",
					"dataType": "rollup",
					"example": "WBVEAD"
				},
				{
					"label": "Victim Relationship to Subject",
					"dataType": "text",
					"example": "Coworker"
				},
				{
					"label": "Subject1 UIC",
					"dataType": "text",
					"example": "WBVEAD"
				},
				{
					"label": "Subject1 Gender",
					"dataType": "text",
					"example": "Male"
				},
				{
					"label": "Subject1 Pay Grade",
					"dataType": "text",
					"example": "E-6"
				}
			]
		},
		"fields": [
			{
				"label": "Case ID",
				"dataType": "number",
				"example": "33449365"
			},
			{
				"label": "DSAID Control Number",
				"dataType": "text",
				"example": "UUAR-00007936-2017-00207"
			},
			{
				"label": "Date of Report to DoD",
				"dataType": "date",
				"example": "1/11/17"
			},
			{
				"label": "Victim Gender",
				"dataType": "text",
				"example": "Female"
			},
			{
				"label": "Victim Age at the Time of Incident",
				"dataType": "number",
				"example": "25"
			},
			{
				"label": "Victim Pay Grade",
				"dataType": "text",
				"example": "E-4"
			},
			{
				"label": "DSAID Case Status",
				"dataType": "text",
				"example": "Closed"
			},
			{
				"label": "Date of Incident",
				"dataType": "date",
				"example": "11/15/16"
			},
			{
				"label": "Was Alcohol Involved? (Subject/Victim)",
				"dataType": "text",
				"example": "Unknown"
			},
			{
				"label": "Victim UIC",
				"dataType": "rollup",
				"example": "WBVEAD"
			},
			{
				"label": "Victim Relationship to Subject",
				"dataType": "text",
				"example": "Coworker"
			},
			{
				"label": "Subject1 UIC",
				"dataType": "text",
				"example": "WBVEAD"
			},
			{
				"label": "Subject1 Gender",
				"dataType": "text",
				"example": "Male"
			},
			{
				"label": "Subject1 Pay Grade",
				"dataType": "text",
				"example": "E-6"
			}
		],
		"lastImportTime": "2022-07-11T20:30:50Z",
		"label": "dsaid_sexual_assaults (1).csv",
		"spreadsheet": true,
		"fileId": 55010
	},
	"fields": [
		{
			"id": 11006,
			"label": "Date+Time Last Deposit",
			"equation": "[Date+Time Last Deposit]",
			"dataType": "date-time",
			"columnName": "date+time last deposit",
			"defaultCalendarId": 1,
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 1901,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 11013,
			"label": "Last Deposit Time of Day",
			"equation": "[Last Deposit Time of Day]",
			"dataType": "time",
			"columnName": "last deposit time of day",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 1901,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 701,
			"label": "Victim Gender",
			"equation": "[Victim Gender]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 702,
			"label": "Victim Age at the Time of Incident",
			"equation": "[Victim Age at the Time of Incident]",
			"dataType": "number",
			"aggregationType": "sum",
			"ranges": [
				{
					"id": 201,
					"label": "< 18 or blank",
					"high": 18,
					"content": [
						"~[blank]~"
					],
					"includeBlank": true
				},
				{
					"id": 202,
					"label": "18 - 24",
					"low": 18,
					"high": 25,
					"content": [],
					"includeBlank": false
				}
			],
			"editable": true,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 703,
			"label": "Case ID",
			"equation": "[Case ID]",
			"dataType": "number",
			"aggregationType": "sum",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"primaryKey": true,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 704,
			"label": "DSAID Control Number",
			"equation": "[DSAID Control Number]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 705,
			"label": "Date of Incident",
			"equation": "[Date of Incident]",
			"dataType": "date",
			"defaultCalendarId": 1,
			"editable": true,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 706,
			"label": "Subject1 Pay Grade",
			"equation": "[Subject1 Pay Grade]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 707,
			"label": "Victim Pay Grade",
			"equation": "[Victim Pay Grade]",
			"dataType": "text",
			"ranges": [
				{
					"id": 101,
					"label": "Civilian",
					"content": [
						"C-1",
						"C-2",
						"C-3",
						"C-4"
					],
					"includeBlank": false
				},
				{
					"id": 102,
					"label": "Enlisted",
					"content": [
						"E-1",
						"E-2",
						"E-3",
						"E-4",
						"E-5",
						"E-6",
						"E-7",
						"E-8",
						"E-9"
					],
					"includeBlank": false
				},
				{
					"id": 103,
					"label": "Officer",
					"content": [
						"O-1",
						"O-2",
						"O-3",
						"O-4",
						"O-5",
						"O-6"
					],
					"includeBlank": false
				},
				{
					"id": 104,
					"label": "Prep School Student",
					"content": [
						"Prep School Student"
					],
					"includeBlank": false
				},
				{
					"id": 105,
					"label": "W",
					"content": [
						"W-1",
						"W-2",
						"W-3"
					],
					"includeBlank": false
				}
			],
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 708,
			"label": "Subject1 Gender",
			"equation": "[Subject1 Gender]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 709,
			"label": "Victim Relationship to Subject",
			"equation": "[Victim Relationship to Subject]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 710,
			"label": "Date of Report to DoD",
			"equation": "[Date of Report to DoD]",
			"dataType": "date",
			"defaultCalendarId": 1,
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 711,
			"label": "DSAID Case Status",
			"equation": "[DSAID Case Status]",
			"dataType": "text",
			"editable": true,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 712,
			"label": "Was Alcohol Involved? (Subject/Victim)",
			"equation": "[Was Alcohol Involved? (Subject/Victim)]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 713,
			"label": "Victim UIC",
			"equation": "[Victim UIC]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 714,
			"label": "Subject1 UIC",
			"equation": "[Subject1 UIC]",
			"dataType": "text",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		},
		{
			"id": 6501,
			"label": "Data Cluster",
			"dataType": "cluster",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "cluster",
			"numClusters": 3,
			"clusteredFieldIds": [
				702
			],
			"invalidForPrimaryKey": false
		},
		{
			"id": 801,
			"label": "Victim Chain of Command",
			"equation": "[Victim UIC]",
			"dataType": "rollup",
			"keySetId": 26,
			"treeId": 1176,
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 802,
			"label": "Responsible SARC (Central)",
			"equation": "right(left([DSAID Control Number],13),8)",
			"dataType": "dataset-link",
			"keySetId": 1,
			"treeId": 1,
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"linkedDatasetId": 112,
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 1303,
			"label": "Responsible SARC (Locations)",
			"equation": " right(left([DSAID Control Number],13),8)",
			"dataType": "dataset-link",
			"keySetId": 1,
			"treeId": 1,
			"editable": true,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"linkedDatasetId": 291,
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 1701,
			"label": "COUNT (calculated = sarc_locations)",
			"equation": "[291].[COUNT] ",
			"dataType": "number",
			"aggregationType": "sum",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"datasetAggregations": [
				{
					"id": 4002,
					"fieldId": 1302,
					"datasetLinkFieldId": 1701,
					"aggregationType": "none",
					"path": "291_1303",
					"labelType": "field-and-aggregation",
					"filters": [],
					"denominatorFilters": [],
					"sortOrder": 0,
					"calculated": false
				}
			],
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 7201,
			"label": "Subject1 Chain of Command",
			"equation": "[Subject1 UIC] ",
			"dataType": "rollup",
			"keySetId": 26,
			"treeId": 1176,
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 7701,
			"label": "Alcohol? Yes/No",
			"equation": "[Was Alcohol Involved? (Subject/Victim)] ",
			"dataType": "yes-no",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 7801,
			"label": "Date of Report to DoD (monthly)",
			"equation": "[Date of Report to DoD] ",
			"dataType": "calendar-period",
			"defaultCalendarId": 1,
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 7802,
			"label": "Incident Date (quarterly)",
			"equation": "[Date of Incident] ",
			"dataType": "calendar-period",
			"defaultCalendarId": 127,
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "calculated",
			"invalidForPrimaryKey": false
		},
		{
			"id": 3801,
			"label": "Record Manually Added",
			"dataType": "yes-no",
			"editable": false,
			"hideFromNonAdmins": false,
			"showKeys": false,
			"stackTrace": null,
			"datasetId": 111,
			"fieldType": "basic",
			"invalidForPrimaryKey": false
		}
	],
	"status": "indexed",
	"stackTrace": null,
	"newAllowed": true,
	"primaryKeyFieldId": 703,
	"primaryKeyEditable": false,
	"primaryKeyLockedExplanation": "The record ID column can't be changed to another column because this dataset is linked with another dataset.",
	"progress": 0,
	"visibleLinkedFields": [
		{
			"id": 3300,
			"label": "INSTALLATION (ViLF from sarc_locations)",
			"fieldId": 1301,
			"path": "291_1303"
		},
		{
			"id": 2600,
			"label": "SARC INSTALLATION",
			"fieldId": 721,
			"path": "112_802,113_721"
		},
		{
			"id": 1001,
			"label": "COUNT",
			"fieldId": 1302,
			"path": "291_1303"
		},
		{
			"id": 4100,
			"label": "Number of sarcs (central)",
			"fieldId": 0,
			"path": "112_802"
		},
		{
			"id": 3500,
			"label": "SA per 1000",
			"fieldId": 1601,
			"path": "112_802,113_721"
		},
		{
			"id": 1400,
			"label": "SOLDIER COUNT",
			"fieldId": 722,
			"path": "112_802,113_721"
		},
		{
			"id": 3600,
			"label": "Number of Installations",
			"fieldId": 0,
			"path": "112_802,113_721"
		},
		{
			"id": 2801,
			"label": "DSAID (sarc central pk)",
			"fieldId": 715,
			"path": "112_802"
		},
		{
			"id": 3101,
			"label": "Fiscal Year",
			"fieldId": 719,
			"path": "112_802,113_721"
		},
		{
			"id": 4102,
			"label": "PK (from IS)",
			"fieldId": 720,
			"path": "112_802,113_721"
		},
		{
			"id": 1000,
			"label": "Number of sarc_locations",
			"fieldId": 0,
			"path": "291_1303"
		},
		{
			"id": 3200,
			"label": "Subject Gender",
			"fieldId": 7206,
			"path": "1125_7205"
		},
		{
			"id": 4003,
			"label": "Installation (sarc central PK)",
			"fieldId": 717,
			"path": "112_802"
		}
	],
	"permissions": [
		{
			"id": 10001,
			"datasetId": 111,
			"principal": {
				"id": -1,
				"type": "user",
				"label": "Administrator, Spider Impact"
			},
			"administer": true,
			"modifyPermissions": true,
			"viewRecords": true,
			"modifyRecords": true,
			"modifyViews": true,
			"matchesUser": true
		},
		{
			"id": 27001,
			"datasetId": 111,
			"principal": {
				"id": 7001,
				"type": "group",
				"label": "Kelly Group",
				"groupType": "admins"
			},
			"filters": [
				{
					"id": 251,
					"linkGroup": 2,
					"deletable": true,
					"fieldId": 712,
					"datasetId": 111,
					"permissionId": 27001,
					"valid": true,
					"operator": "is-any",
					"values": [
						"No"
					],
					"fromChartSerie": false
				},
				{
					"id": 252,
					"linkGroup": 3,
					"deletable": true,
					"fieldId": 711,
					"datasetId": 111,
					"permissionId": 27001,
					"valid": true,
					"operator": "is-any",
					"values": [
						"Open"
					],
					"fromChartSerie": false
				},
				{
					"id": 221,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 27001,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"61": "rollups-only"
					},
					"fromChartSerie": false,
					"treeIds": [
						61
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": false,
			"modifyRecords": false,
			"modifyViews": false,
			"matchesUser": false
		},
		{
			"id": 29003,
			"datasetId": 111,
			"principal": {
				"id": 9001,
				"type": "group",
				"label": "zed group",
				"groupType": "admins"
			},
			"filters": [
				{
					"id": 272,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 29003,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"61": "item-rollups-and-descendants"
					},
					"fromChartSerie": false,
					"treeIds": [
						61
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": false,
			"modifyRecords": false,
			"modifyViews": false,
			"matchesUser": false
		},
		{
			"id": 29004,
			"datasetId": 111,
			"principal": {
				"id": 9002,
				"type": "group",
				"label": "imperius group",
				"groupType": "admins"
			},
			"filters": [
				{
					"id": 273,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 29004,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"61": "item-rollups-and-children"
					},
					"fromChartSerie": false,
					"treeIds": [
						61
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": false,
			"modifyRecords": false,
			"modifyViews": false,
			"matchesUser": false
		},
		{
			"id": 30001,
			"datasetId": 111,
			"principal": {
				"id": 10001,
				"type": "group",
				"label": "roseanne group",
				"groupType": "admins"
			},
			"filters": [
				{
					"id": 281,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 30001,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"34": "item-rollups-children-and-grandchildren"
					},
					"fromChartSerie": false,
					"treeIds": [
						34
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": false,
			"modifyRecords": false,
			"modifyViews": false,
			"matchesUser": false
		},
		{
			"id": 30002,
			"datasetId": 111,
			"principal": {
				"id": 10002,
				"type": "group",
				"label": "dan group",
				"groupType": "view-only"
			},
			"filters": [
				{
					"id": 282,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 30002,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"34": "item-rollups-and-descendants"
					},
					"fromChartSerie": false,
					"treeIds": [
						34
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": false,
			"modifyRecords": false,
			"modifyViews": false,
			"matchesUser": false
		},
		{
			"id": 31001,
			"datasetId": 111,
			"principal": {
				"id": 4002,
				"type": "group",
				"label": "cathy group",
				"groupType": "admins"
			},
			"filters": [
				{
					"id": 291,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 31001,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"33": "item-rollups-and-descendants"
					},
					"fromChartSerie": false,
					"treeIds": [
						33
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": true,
			"modifyRecords": true,
			"modifyViews": false,
			"matchesUser": false
		},
		{
			"id": 32002,
			"datasetId": 111,
			"principal": {
				"id": 11001,
				"type": "group",
				"label": "wanda group",
				"groupType": "admins"
			},
			"filters": [
				{
					"id": 302,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 32002,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"2": "item-rollups-and-descendants"
					},
					"fromChartSerie": false,
					"treeIds": [
						2
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": false,
			"modifyRecords": false,
			"modifyViews": false,
			"matchesUser": false
		},
		{
			"id": 32003,
			"datasetId": 111,
			"principal": {
				"id": 11002,
				"type": "group",
				"label": "vision group",
				"groupType": "view-only"
			},
			"filters": [
				{
					"id": 303,
					"linkGroup": 1,
					"deletable": true,
					"fieldId": 1303,
					"datasetId": 111,
					"permissionId": 32003,
					"valid": true,
					"operator": "is-any",
					"rollupIsAnyFilters": {
						"4": "item-rollups-and-descendants",
						"300": "item-rollups-and-descendants"
					},
					"fromChartSerie": false,
					"treeIds": [
						4,
						300
					]
				}
			],
			"administer": false,
			"modifyPermissions": false,
			"viewRecords": false,
			"modifyRecords": false,
			"modifyViews": false,
			"matchesUser": false
		}
	],
	"scheduleData": {},
	"locale": "en_US",
	"manuallyAddedFieldId": 3801,
	"numTracked": 3130,
	"onlyUniquePaths": [
		112,
		113,
		291,
		1125
	],
	"linkedDatasets": [
		{
			"id": 113,
			"label": "installation_strength ",
			"rootId": 114,
			"tracked": "Installations",
			"fields": [
				{
					"id": 719,
					"label": "Fiscal Year",
					"equation": "[Fiscal Year]",
					"dataType": "date",
					"defaultCalendarId": 1,
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 113,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 720,
					"label": "PK",
					"equation": "[PK]",
					"dataType": "number",
					"aggregationType": "sum",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"primaryKey": true,
					"stackTrace": null,
					"datasetId": 113,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 721,
					"label": "SARC INSTALLATION",
					"equation": "[SARC INSTALLATION]",
					"dataType": "dataset-link",
					"keySetId": 1,
					"treeId": 1,
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 113,
					"linkedDatasetId": 112,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 722,
					"label": "SOLDIER COUNT",
					"equation": "[SOLDIER COUNT]",
					"dataType": "number",
					"aggregationType": "sum",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 113,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 1402,
					"label": "Soldier Count (None)",
					"equation": "[SOLDIER COUNT] ",
					"dataType": "number",
					"aggregationType": "none",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 113,
					"fieldType": "calculated",
					"invalidForPrimaryKey": false
				},
				{
					"id": 1601,
					"label": "SA per 1000",
					"equation": "1000 * [111].[Total sexual assaults] / [SOLDIER COUNT]",
					"dataType": "number",
					"aggregationType": "sum",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 113,
					"datasetAggregations": [
						{
							"id": 2001,
							"fieldId": 0,
							"datasetLinkFieldId": 1601,
							"aggregationType": "sum",
							"path": "112_721,111_802",
							"labelType": "field-and-aggregation",
							"filters": [],
							"denominatorFilters": [],
							"sortOrder": 0,
							"calculated": false
						},
						{
							"id": 2002,
							"fieldId": 0,
							"datasetLinkFieldId": 1601,
							"aggregationType": "sum",
							"path": "112_721,111_802",
							"labelType": "field-and-aggregation",
							"filters": [],
							"denominatorFilters": [],
							"sortOrder": 1,
							"calculated": false
						}
					],
					"fieldType": "calculated",
					"invalidForPrimaryKey": false
				},
				{
					"id": 7001,
					"label": "Latest date of incident (calculated)",
					"equation": "[111].[Date of Incident]   ",
					"dataType": "date",
					"aggregationType": "maximum",
					"defaultCalendarId": 2,
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 113,
					"datasetAggregations": [
						{
							"id": 34001,
							"fieldId": 705,
							"datasetLinkFieldId": 7001,
							"aggregationType": "maximum",
							"path": "112_721,111_802",
							"labelType": "field-and-aggregation",
							"filters": [],
							"denominatorFilters": [],
							"sortOrder": 0,
							"calculated": false
						}
					],
					"fieldType": "calculated",
					"invalidForPrimaryKey": false
				}
			],
			"status": "indexed",
			"stackTrace": null,
			"newAllowed": false,
			"primaryKeyFieldId": 720,
			"progress": 0,
			"visibleLinkedFields": [
				{
					"id": 1201,
					"label": "Number of sexual assaults",
					"fieldId": 0,
					"path": "112_721,111_802"
				},
				{
					"id": 3900,
					"label": "Case ID",
					"fieldId": 703,
					"path": "112_721,111_802"
				},
				{
					"id": 4101,
					"label": "Number of sarcs",
					"fieldId": 0,
					"path": "112_721"
				},
				{
					"id": 1200,
					"label": "Subject1 Pay Grade",
					"fieldId": 706,
					"path": "112_721,111_802"
				},
				{
					"id": 3100,
					"label": "Responsible SARC (Central)",
					"fieldId": 802,
					"path": "112_721,111_802"
				},
				{
					"id": 1600,
					"label": "Responsible SARC (Locations)",
					"fieldId": 1303,
					"path": "112_721,111_802"
				},
				{
					"id": 2900,
					"label": "Date of Incident",
					"fieldId": 705,
					"path": "112_721,111_802"
				}
			],
			"scheduleData": {},
			"locale": "en_US",
			"numTracked": 116,
			"onlyUniquePaths": null,
			"root": {
				"id": 114,
				"label": "DatasetsQueryDaoIntegrationTest",
				"fields": [],
				"stackTrace": null,
				"newAllowed": false,
				"progress": 0,
				"scheduleData": {},
				"onlyUniquePaths": null,
				"view": true,
				"projectId": 1,
				"organizationId": 1,
				"organizationLabel": "Root",
				"hasRecordsManuallyAdded": false,
				"hasSupplementalRecords": false,
				"junctionDataset": false,
				"datasetOrDescendant": false,
				"administer": true,
				"modifyPermissions": true,
				"viewRecords": true,
				"modifyRecords": true,
				"modifyViews": true,
				"complete": false,
				"building": false,
				"canView": true,
				"type": "folder",
				"hasUnfilteredPermission": false
			},
			"rootDatasetId": 113,
			"replaceAllRecords": false,
			"projectId": 1,
			"organizationId": 1,
			"organizationLabel": "Root",
			"previousPrimaryKeyFieldId": 720,
			"hasRecordsManuallyAdded": false,
			"hasSupplementalRecords": false,
			"junctionDataset": false,
			"datasetOrDescendant": true,
			"administer": true,
			"modifyPermissions": true,
			"viewRecords": true,
			"modifyRecords": true,
			"modifyViews": true,
			"complete": true,
			"building": false,
			"canView": true,
			"type": "dataset",
			"hasUnfilteredPermission": false
		},
		{
			"id": 291,
			"label": "sarc_locations",
			"rootId": 114,
			"tracked": "sarc_locations",
			"fields": [
				{
					"id": 1301,
					"label": "INSTALLATION",
					"equation": "[INSTALLATION]",
					"dataType": "rollup",
					"keySetId": 1,
					"treeId": 1,
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"primaryKey": true,
					"stackTrace": null,
					"datasetId": 291,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 1302,
					"label": "COUNT",
					"equation": "[COUNT]",
					"dataType": "number",
					"aggregationType": "sum",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 291,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 1304,
					"label": "SA per 1000",
					"equation": "1000 * [111].[Total sexual assaults] / [COUNT]",
					"dataType": "number",
					"aggregationType": "none",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 291,
					"datasetAggregations": [
						{
							"id": 1001,
							"fieldId": 0,
							"datasetLinkFieldId": 1304,
							"aggregationType": "sum",
							"path": "111_1303",
							"labelType": "field-and-aggregation",
							"filters": [],
							"denominatorFilters": [],
							"sortOrder": 0,
							"calculated": false
						},
						{
							"id": 1002,
							"fieldId": 0,
							"datasetLinkFieldId": 1304,
							"aggregationType": "sum",
							"path": "111_1303",
							"labelType": "field-and-aggregation",
							"filters": [],
							"denominatorFilters": [],
							"sortOrder": 1,
							"calculated": false
						}
					],
					"fieldType": "calculated",
					"invalidForPrimaryKey": false
				},
				{
					"id": 1401,
					"label": "Count (none)",
					"equation": "[COUNT] ",
					"dataType": "number",
					"aggregationType": "none",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 291,
					"fieldType": "calculated",
					"invalidForPrimaryKey": false
				}
			],
			"status": "indexed",
			"stackTrace": null,
			"newAllowed": false,
			"primaryKeyFieldId": 1301,
			"progress": 0,
			"visibleLinkedFields": [
				{
					"id": 1100,
					"label": "Date of Incident",
					"fieldId": 705,
					"path": "111_1303"
				},
				{
					"id": 1801,
					"label": "Number of sexual assaults",
					"fieldId": 0,
					"path": "111_1303"
				},
				{
					"id": 3102,
					"label": "Victim Chain of Command",
					"fieldId": 801,
					"path": "111_1303"
				},
				{
					"id": 1800,
					"label": "Victim Age at the Time of Incident",
					"fieldId": 702,
					"path": "111_1303"
				},
				{
					"id": 3103,
					"label": "Subject1 Chain of Command",
					"fieldId": 7201,
					"path": "111_1303"
				},
				{
					"id": 3801,
					"label": "Responsible SARC (Locations)",
					"fieldId": 1303,
					"path": "111_1303"
				},
				{
					"id": 3802,
					"label": "Subjects Gender",
					"fieldId": 7206,
					"path": "111_1303,1125_7205"
				}
			],
			"scheduleData": {},
			"locale": "en_US",
			"numTracked": 30,
			"onlyUniquePaths": null,
			"root": {
				"id": 114,
				"label": "DatasetsQueryDaoIntegrationTest",
				"fields": [],
				"stackTrace": null,
				"newAllowed": false,
				"progress": 0,
				"scheduleData": {},
				"onlyUniquePaths": null,
				"view": true,
				"projectId": 1,
				"organizationId": 1,
				"organizationLabel": "Root",
				"hasRecordsManuallyAdded": false,
				"hasSupplementalRecords": false,
				"junctionDataset": false,
				"datasetOrDescendant": false,
				"administer": true,
				"modifyPermissions": true,
				"viewRecords": true,
				"modifyRecords": true,
				"modifyViews": true,
				"complete": false,
				"building": false,
				"canView": true,
				"type": "folder",
				"hasUnfilteredPermission": false
			},
			"rootDatasetId": 291,
			"replaceAllRecords": true,
			"projectId": 1,
			"organizationId": 1,
			"organizationLabel": "Root",
			"previousPrimaryKeyFieldId": 1301,
			"hasRecordsManuallyAdded": false,
			"hasSupplementalRecords": false,
			"junctionDataset": false,
			"datasetOrDescendant": true,
			"administer": true,
			"modifyPermissions": true,
			"viewRecords": true,
			"modifyRecords": true,
			"modifyViews": true,
			"complete": true,
			"building": false,
			"canView": true,
			"type": "dataset",
			"hasUnfilteredPermission": false
		},
		{
			"id": 1125,
			"label": "Subjects",
			"rootId": 114,
			"tracked": "Subjects",
			"fields": [
				{
					"id": 7202,
					"label": "Pay Grade",
					"equation": "[Pay Grade]",
					"dataType": "text",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 1125,
					"fieldType": "basic"
				},
				{
					"id": 7203,
					"label": "DSAID Control Number (subjects)",
					"equation": "[DSAID Control Number (subjects)]",
					"dataType": "text",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 1125,
					"fieldType": "basic"
				},
				{
					"id": 7204,
					"label": "Subject Chain of Command",
					"equation": "[Subject Chain of Command]",
					"dataType": "text",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 1125,
					"fieldType": "basic"
				},
				{
					"id": 7205,
					"label": "Case ID (subjects)",
					"equation": "[Case ID (subjects)]",
					"dataType": "dataset-link",
					"aggregationType": "sum",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 1125,
					"linkedDatasetId": 111,
					"fieldType": "basic"
				},
				{
					"id": 7206,
					"label": "Gender",
					"equation": "[Gender]",
					"dataType": "text",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 1125,
					"fieldType": "basic"
				}
			],
			"status": "indexed",
			"stackTrace": null,
			"newAllowed": false,
			"progress": 0,
			"visibleLinkedFields": [
				{
					"id": 3400,
					"label": "Number of sexual assaults",
					"fieldId": 0,
					"path": "111_7205"
				}
			],
			"scheduleData": {},
			"locale": "en_US",
			"numTracked": 300,
			"onlyUniquePaths": null,
			"root": {
				"id": 114,
				"label": "DatasetsQueryDaoIntegrationTest",
				"fields": [],
				"stackTrace": null,
				"newAllowed": false,
				"progress": 0,
				"scheduleData": {},
				"onlyUniquePaths": null,
				"view": true,
				"projectId": 1,
				"organizationId": 1,
				"organizationLabel": "Root",
				"hasRecordsManuallyAdded": false,
				"hasSupplementalRecords": false,
				"junctionDataset": false,
				"datasetOrDescendant": false,
				"administer": true,
				"modifyPermissions": true,
				"viewRecords": true,
				"modifyRecords": true,
				"modifyViews": true,
				"complete": false,
				"building": false,
				"canView": true,
				"type": "folder",
				"hasUnfilteredPermission": false
			},
			"rootDatasetId": 1125,
			"projectId": 1,
			"organizationId": 1,
			"organizationLabel": "Root",
			"hasRecordsManuallyAdded": false,
			"hasSupplementalRecords": false,
			"junctionDataset": false,
			"datasetOrDescendant": true,
			"administer": true,
			"modifyPermissions": true,
			"viewRecords": true,
			"modifyRecords": true,
			"modifyViews": true,
			"complete": true,
			"building": false,
			"canView": true,
			"type": "dataset",
			"hasUnfilteredPermission": false
		},
		{
			"id": 112,
			"label": "sarc_central - good",
			"rootId": 114,
			"tracked": "sarcs",
			"fields": [
				{
					"id": 715,
					"label": "DSAID",
					"equation": "[DSAID]",
					"dataType": "rollup",
					"keySetId": 1,
					"treeId": 1,
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"primaryKey": true,
					"stackTrace": null,
					"datasetId": 112,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 716,
					"label": "Combined",
					"equation": "[Combined]",
					"dataType": "text",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 112,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 717,
					"label": "Installation",
					"equation": "[Installation]",
					"dataType": "text",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 112,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 718,
					"label": "Soldiers",
					"equation": "[Soldiers]",
					"dataType": "number",
					"aggregationType": "sum",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 112,
					"fieldType": "basic",
					"invalidForPrimaryKey": false
				},
				{
					"id": 7101,
					"label": "Avg victim age",
					"equation": "[111].[Victim Age at the Time of Incident] ",
					"dataType": "number",
					"aggregationType": "sum",
					"editable": false,
					"hideFromNonAdmins": false,
					"showKeys": false,
					"stackTrace": null,
					"datasetId": 112,
					"datasetAggregations": [
						{
							"id": 37001,
							"fieldId": 702,
							"datasetLinkFieldId": 7101,
							"aggregationType": "average",
							"path": "111_802",
							"labelType": "field-and-aggregation",
							"filters": [],
							"denominatorFilters": [],
							"sortOrder": 0,
							"calculated": false
						}
					],
					"fieldType": "calculated",
					"invalidForPrimaryKey": false
				}
			],
			"status": "indexed",
			"stackTrace": null,
			"newAllowed": false,
			"primaryKeyFieldId": 715,
			"progress": 0,
			"visibleLinkedFields": [
				{
					"id": 2800,
					"label": "Number of sexual assaults",
					"fieldId": 0,
					"path": "111_802"
				},
				{
					"id": 1300,
					"label": "SOLDIER COUNT",
					"fieldId": 722,
					"path": "113_721"
				},
				{
					"id": 2700,
					"label": "Subject1 Pay Grade",
					"fieldId": 706,
					"path": "111_802"
				},
				{
					"id": 4002,
					"label": "Case ID",
					"fieldId": 703,
					"path": "111_802"
				},
				{
					"id": 4001,
					"label": "Responsible SARC (Central)",
					"fieldId": 802,
					"path": "111_802"
				},
				{
					"id": 1900,
					"label": "Victim Chain of Command",
					"fieldId": 801,
					"path": "111_802"
				},
				{
					"id": 1500,
					"label": "Date of Incident",
					"fieldId": 705,
					"path": "111_802"
				},
				{
					"id": 2400,
					"label": "Victim Age at the Time of Incident",
					"fieldId": 702,
					"path": "111_802"
				},
				{
					"id": 2701,
					"label": "Fiscal Year",
					"fieldId": 719,
					"path": "113_721"
				}
			],
			"scheduleData": {},
			"locale": "en_US",
			"numTracked": 581,
			"onlyUniquePaths": null,
			"root": {
				"id": 114,
				"label": "DatasetsQueryDaoIntegrationTest",
				"fields": [],
				"stackTrace": null,
				"newAllowed": false,
				"progress": 0,
				"scheduleData": {},
				"onlyUniquePaths": null,
				"view": true,
				"projectId": 1,
				"organizationId": 1,
				"organizationLabel": "Root",
				"hasRecordsManuallyAdded": false,
				"hasSupplementalRecords": false,
				"junctionDataset": false,
				"datasetOrDescendant": false,
				"administer": true,
				"modifyPermissions": true,
				"viewRecords": true,
				"modifyRecords": true,
				"modifyViews": true,
				"complete": false,
				"building": false,
				"canView": true,
				"type": "folder",
				"hasUnfilteredPermission": false
			},
			"rootDatasetId": 112,
			"replaceAllRecords": true,
			"projectId": 1,
			"organizationId": 1,
			"organizationLabel": "Root",
			"previousPrimaryKeyFieldId": 715,
			"hasRecordsManuallyAdded": false,
			"hasSupplementalRecords": false,
			"junctionDataset": false,
			"datasetOrDescendant": true,
			"administer": true,
			"modifyPermissions": true,
			"viewRecords": true,
			"modifyRecords": true,
			"modifyViews": true,
			"complete": true,
			"building": false,
			"canView": true,
			"type": "dataset",
			"hasUnfilteredPermission": false
		}
	],
	"view": true,
	"oneDatasetIds": [
		112,
		291,
		111
	],
	"root": {
		"id": 114,
		"label": "DatasetsQueryDaoIntegrationTest",
		"fields": [],
		"stackTrace": null,
		"newAllowed": false,
		"progress": 0,
		"scheduleData": {},
		"onlyUniquePaths": null,
		"view": true,
		"projectId": 1,
		"organizationId": 1,
		"organizationLabel": "Root",
		"hasRecordsManuallyAdded": false,
		"hasSupplementalRecords": false,
		"junctionDataset": false,
		"datasetOrDescendant": false,
		"administer": true,
		"modifyPermissions": true,
		"viewRecords": true,
		"modifyRecords": true,
		"modifyViews": true,
		"complete": false,
		"building": false,
		"canView": true,
		"type": "folder",
		"hasUnfilteredPermission": false
	},
	"rootDatasetId": 111,
	"replaceAllRecords": true,
	"projectId": 1,
	"organizationId": 1,
	"organizationLabel": "Root",
	"formIds": [
		1,
		2001,
		2,
		727,
		602,
		603,
		604,
		2301,
		2302
	],
	"previousPrimaryKeyFieldId": 703,
	"hasRecordsManuallyAdded": false,
	"hasSupplementalRecords": false,
	"junctionDataset": false,
	"datasetOrDescendant": true,
	"allUniquePaths": true,
	"administer": true,
	"modifyPermissions": true,
	"viewRecords": true,
	"modifyRecords": true,
	"modifyViews": true,
	"complete": true,
	"building": false,
	"canView": true,
	"source": "upload",
	"type": "dataset",
	"hasUnfilteredPermission": true
}
